import {
  TKhattabatMessage,
  TalkhattabatConversationType,
  E_KHATTABAT_APPLICATION_STATUS
} from "../../../../../../Types";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";
import SendMessage from "./SendMessage";
import UsersMessages from "./UsersMessages";
import { isPositiveNumber } from "et3-type-guards";

const Messages = withLiteObserverAndTheme<{
  messages: TKhattabatMessage[];
  conversationID: string;
  alkhattabaUUID: string;
  userUUID: string;
  userID: number;
  peerID: number;
  peerUUID: string;
  conversationType: TalkhattabatConversationType;
  oneOTwoConversationId: string;
  oneOOneCId: string;
  applicationStatus: string
}>((props) => {
  const {
    theme,
    messages,
    conversationID,
    alkhattabaUUID,
    userUUID,
    peerID,
    peerUUID,
    userID,
    conversationType,
    oneOTwoConversationId,
    oneOOneCId,
    applicationStatus
  } = props;
  const { colors } = theme;
  const borderColor = isPositiveNumber(
    ["101C_COMMENTS", "101M_COMMENTS"].indexOf(conversationType),
    true
  )
    ? `5px solid ${colors.all.red}`
    : `1px solid ${colors.all.black}`;
  const ONE_O_ONE_CONVERSATION_TYPES: TalkhattabatConversationType[] = [
    "101C",
    "101C_COMMENTS"
  ];

  const isOneOOneConversationType =
    ONE_O_ONE_CONVERSATION_TYPES.includes(conversationType);

  const shouldHideSendingMessages =
    applicationStatus === E_KHATTABAT_APPLICATION_STATUS.NONE &&
    isOneOOneConversationType;

  return (
    <ET3Div
      width={1188}
      height={428}
      alignItems={"center"}
      fDirection={"column"}
      style={{
        border: borderColor,
        borderRadius: 20,
        overflow: "hidden"
      }}
      color={""}
      justifyContent={"flex-end"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => { }}
    >
      <UsersMessages messages={messages} />
      <Et3Margin top={5} bottom={5} left={0} right={0} />
      {shouldHideSendingMessages ? null : <SendMessage
        conversationID={conversationID}
        oneOTwoConversationId={oneOTwoConversationId}
        alkhattabaUUID={alkhattabaUUID}
        userUUID={userUUID}
        userID={userID}
        peerID={peerID}
        peerUUID={peerUUID}
        conversationType={conversationType}
        oneOOneCId={oneOOneCId}
      />}
    </ET3Div>
  );
});

export default Messages;
